import React, { ReactNode } from "react";
import { useDispatch, useSelector } from "react-redux";
import { config } from "../config";
import {
  setFavoritesShow,
  setLogged,
  setRemindersShow,
  setRoutesShow,
  setTeamActivityShow,
  setTriggerRegister,
  setUserData,
} from "../store/reducers/listingReducer";
import * as Menubar from "@radix-ui/react-menubar";
import * as Dialog from "@radix-ui/react-dialog";
import { ReactComponent as Bell } from "../assets/svg/bell.svg";
import { ReactComponent as Plus } from "../assets/svg/plus.svg";
import { ReactComponent as Menu } from "../assets/svg/menu-01.svg";
import { ReactComponent as AlignRight } from "../assets/svg/align-right-01.svg";
import { ReactComponent as Filter } from "../assets/svg/filter-funnel-02.svg";
import { ReactComponent as Heart } from "../assets/svg/heart.svg";
import { ReactComponent as List } from "../assets/svg/list.svg";
import { ReactComponent as Route } from "../assets/svg/route.svg";
import { ReactComponent as UserCircle } from "../assets/svg/user-circle.svg";
import { ReactComponent as Users } from "../assets/svg/users-03.svg";
import { ReactComponent as Settings } from "../assets/svg/settings.svg";
import { ReactComponent as Logo } from "../assets/svg/logo.svg";
import ImportListing from "./ImportListing";
import { Link, useParams } from "react-router-dom";
import Login from "./Login";
import { callLogout } from "../services/api";
import { MobileNav } from "./ui/MobileNav";
import { LeadsDialog } from "./user/ManageLeads";
import { useMediaQuery } from "@uidotdev/usehooks";
import Register from "./Register";
import { PrintDocs } from "./PrintDocs";
import { FilterListing } from "./filters/NewFilterListing";

interface IProps {}

export const Header = (props: IProps) => {
  const dispatch = useDispatch();
  const logged = useSelector((state: any) => state.listingReducer.logged);
  const userReminders = useSelector(
    (state: any) => state.listingReducer.userReminders
  );
  const userData = useSelector((state: any) => state.listingReducer.userData);
  const triggerRegister = useSelector(
    (state: any) => state.listingReducer.triggerRegister
  );
  const [showMenu, setShowMenu] = React.useState<boolean>(false);
  const [showLogin, setShowLogin] = React.useState(false);
  const [showRegister, setShowRegister] = React.useState(false);
  const [showMobileNav, setShowMobileNav] = React.useState(false);
  let { token } = useParams();

  React.useEffect(() => {
    if (token && token !== "" && token !== undefined && !logged) {
      dispatch(setTriggerRegister(true));
    }
  }, [token]);

  React.useEffect(() => {
    if (triggerRegister) {
      setShowRegister(true);
      dispatch(setTriggerRegister(false));
    }
  }, [triggerRegister]);

  function handleFavorites() {
    dispatch(setRemindersShow(false));
    dispatch(setRoutesShow(false));
    dispatch(setTeamActivityShow(false));
    dispatch(setFavoritesShow(true));
  }

  function handleReminders() {
    dispatch(setFavoritesShow(false));
    dispatch(setRoutesShow(false));
    dispatch(setTeamActivityShow(false));
    dispatch(setRemindersShow(true));
  }

  function handleRoutes() {
    dispatch(setFavoritesShow(false));
    dispatch(setRemindersShow(false));
    dispatch(setTeamActivityShow(false));
    dispatch(setRoutesShow(true));
  }

  function handleTeamActivity() {
    dispatch(setFavoritesShow(false));
    dispatch(setRemindersShow(false));
    dispatch(setRoutesShow(false));
    dispatch(setTeamActivityShow(true));
  }

  function getRemindersCount() {
    let unread = userReminders.filter((item: any) => item.user_read === "0");
    return unread.length;
  }

  function handleMenu() {
    if (showMenu) {
      setShowMenu(false);
    } else {
      setShowMenu(true);
    }
  }

  const logout = async () => {
    await callLogout();
    dispatch(setLogged(false));
    dispatch(setUserData(null));
    localStorage.removeItem("listings-app-login");
    return true;
  };

  const isSmallScreen = useMediaQuery("(max-width: 640px)");

  return (
    <>
      <header className=" min-h-[4.5rem] fixed z-10 bg-white top-0">
        <div className="px-8 py-4 flex justify-between items-center shadow-md border-b border-b-gray-300">
          <div>
            <Link to="/">
              <Logo />
            </Link>
          </div>

          {logged ? (
            <div className="block md:hidden">
              <button onClick={() => setShowMobileNav((state) => !state)}>
                <Menu />
              </button>
            </div>
          ) : null}

          {!logged ? (
            <button
              onClick={() => setShowLogin(true)}
              className="block md:hidden text-gray-600"
            >
              Login
            </button>
          ) : null}

          {!logged ? (
            <button
              onClick={() => setShowRegister(true)}
              className="block md:hidden text-gray-600"
            >
              Register
            </button>
          ) : null}

          <div className="hidden md:flex gap-x-8 font-semibold text-gray-600">
            {!logged ? (
              <button
                onClick={() => setShowLogin(true)}
                className="text-gray-600"
              >
                Login
              </button>
            ) : (
              ""
            )}
            {/* <Login close={() => setShowLogin(false)} isOpen={showLogin} /> */}
            {!logged ? (
              <button
                onClick={() => setShowRegister(true)}
                className="text-gray-600"
              >
                Register
              </button>
            ) : null}
            {/* {showRegister ? (
              <Register
                close={() => setShowRegister(false)}
                isOpen={showRegister}
              />
            ) : null} */}
            <PrintDocs />
            {logged ? (
              <Link
                to={"/add-listing"}
                className="flex items-center gap-x-1 text-gray-600"
              >
                <span>
                  <Plus />
                </span>
                <span>Add Listing</span>
              </Link>
            ) : null}

            {logged ? <ImportListing /> : null}

            <div className="flex items-center">
              <Link className="relative" to={"/reminders"}>
                <Bell />
                {getRemindersCount() > 0 ? (
                  <div className="bg-red-600 text-white text-xs rounded-full h-4 w-4 text-center absolute -top-2 right-0 ">
                    {getRemindersCount()}
                  </div>
                ) : null}
              </Link>

              {logged ? (
                <div className="ml-3">
                  <Dialog.Root>
                    <Menubar.Root>
                      <Menubar.Menu>
                        <Menubar.Trigger>
                          <img
                            className="w-10 h-10 rounded-full object-cover"
                            src={
                              userData?.user_profile_filename
                                ? `${config.apiUrl}profile-picture?public_id=${userData?.public_id}`
                                : "https://api.dicebear.com/8.x/lorelei/svg"
                            }
                            alt="avatar"
                          />
                        </Menubar.Trigger>
                        <Menubar.Portal>
                          <Menubar.Content
                            className="z-10 w-52 bg-white border shadow-lg mt-3"
                            align="end"
                          >
                            <MenuItem
                              icon={<UserCircle />}
                              text="View profile"
                              to="/profile"
                            />
                            <MenuItem
                              icon={<Users />}
                              text="My Team"
                              to="/my-team"
                            />
                            <MenuItem
                              icon={<List />}
                              text="My Team Activity"
                              to="/my-team-activity"
                            />
                            <MenuItem
                              icon={<List />}
                              text="Manage Notification"
                              to="/manage-notification"
                            />
                            {isSmallScreen ? (
                              <MenuItem
                                icon={<Filter />}
                                text="Manage Leads"
                                to="/manage-leads"
                              />
                            ) : (
                              <Dialog.Trigger asChild>
                                <Menubar.Item className="px-4 py-2 flex items-center gap-x-2 text-gray-700 font-medium text-sm">
                                  <button className="flex items-center gap-x-2">
                                    <span>
                                      <Filter />
                                    </span>
                                    <span>Manage Leads</span>
                                  </button>
                                </Menubar.Item>
                              </Dialog.Trigger>
                            )}
                            <MenuItem
                              icon={<Route />}
                              text="Routes"
                              to="/routes"
                            />
                            {userData?.team_owner ? (
                              <MenuItem
                                icon={<Route />}
                                text="Team Routes"
                                to="/team-routes"
                              />
                            ) : null}
                            {userData?.team_owner &&
                            userData?.post_mail === 1 ? (
                              <MenuItem
                                icon={<Route />}
                                text="Post Mail"
                                to="/post-mail"
                              />
                            ) : null}
                            <MenuItem
                              icon={<Heart />}
                              text="Favourite"
                              to="/favourites"
                            />
                            <Menubar.Item className="px-4 py-2 flex items-center gap-x-2 text-gray-700 font-medium text-sm">
                              <button
                                className="flex items-center gap-x-2"
                                onClick={logout}
                              >
                                <span>
                                  <AlignRight />
                                </span>
                                <span>Logout</span>
                              </button>
                            </Menubar.Item>
                          </Menubar.Content>
                        </Menubar.Portal>
                      </Menubar.Menu>
                    </Menubar.Root>
                    <LeadsDialog />
                  </Dialog.Root>
                </div>
              ) : null}
            </div>
          </div>
        </div>
        {logged ? <FilterListing /> : null}
      </header>
      {showMobileNav ? (
        <MobileNav close={() => setShowMobileNav(false)} />
      ) : null}
    </>
  );
};

const MenuItem = ({
  icon,
  text,
  to,
}: {
  icon: ReactNode;
  to: string;
  text: string;
}) => {
  return (
    <Menubar.Item className="px-4 py-2 flex items-center gap-x-2 text-gray-700 font-medium text-sm">
      <Link className="flex text-gray-700 gap-x-2" to={to}>
        <span>{icon}</span>
        <span>{text}</span>
      </Link>
    </Menubar.Item>
  );
};
export default Header;
